"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CierreMetodologia() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="237001" id="cierre-metodologia" className="relative bg-background text-foreground py-32 md:py-40 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: "url(https://fulcro.mx/wp-content/uploads/2026/04/fulcro-textura-fulcrums-dark.svg)",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      opacity: 0.20
    }} aria-hidden="true" />

      <div ref={ref} className={`relative z-10 max-w-3xl mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-normal text-foreground leading-tight mb-10">
          El método protege contra la moda.
        </h2>

        <div className="space-y-6 font-sans text-lg text-foreground/90 leading-relaxed mb-12">
          <p>
            Cinco fases que se cumplen sin importar qué tecnología esté de moda. Si mañana la IA generativa pasa al segundo plano y la siguiente ola es otra cosa, el método aplica igual.
          </p>
          <p>
            Lo que cambia son las herramientas. Lo que no cambia es el criterio: primero el proceso, después la tecnología.
          </p>
        </div>

        <Button asChild size="lg" className="h-14 px-8 text-base font-medium bg-primary hover:bg-primary/90 text-primary-foreground rounded-sm transition-colors">
          <Link to="https://fulcro.mx/contacto/">
            Hablemos 30 minutos
            <ArrowRight className="ml-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}